import { ButtonHTMLAttributes, forwardRef, memo } from "react";
import classNames from "classnames";
import { TagSize } from "../Tag";

import { ReactComponent as CloseIcon } from "./icons/close.svg";

import styles from "./styles.module.scss";

export type TagCloseProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  tagSize?: TagSize,
}

export const TagClose = memo(forwardRef<HTMLButtonElement, TagCloseProps>(({ tagSize = "md", className, ...props }, ref) => {
  return (
    <button
      className={classNames(className, styles.closeButton, styles[tagSize as keyof typeof styles])}
      type="button"
      {...props}
      ref={ref}
    >
      <CloseIcon />
    </button>
  );
}));